import { ACCURACY_NOTICE } from "@vrqc/shared";

export function Disclaimer() {
  return <p className="notice notice-strong">{ACCURACY_NOTICE}</p>;
}
